__turbopack_context__.v({
  "companyInfo": "Terms-module__0dfTdW__companyInfo",
  "dateInfo": "Terms-module__0dfTdW__dateInfo",
  "termsContainer": "Terms-module__0dfTdW__termsContainer",
  "termsContent": "Terms-module__0dfTdW__termsContent",
  "termsFooter": "Terms-module__0dfTdW__termsFooter",
  "termsHeader": "Terms-module__0dfTdW__termsHeader",
});
